import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { IVasInfo } from '@r1-frontend/api-domru/api-profile/v1/vas/dto/ResponseDto';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import { fetchSubscriptions } from '~/src/features/domru-tv/packages/store/actions/fetchSubscriptions';
import { usePrepareQueryData } from '~/src/helpers/hooks/usePrepareQueryData';
import { IFullMultibundle, IMultibundleAdditional, ISubscriptionAdditional, multiBundleId } from '~/src/store/selectors/vas';

import MultibundleCard from '../MultiBundleCard';
import MultibundleWidget from '../MultibundleWidget';
import SubscriptionCard from '../SubscriptionCard';

interface IProps {
    subscriptions: Array<IVasInfo<ISubscriptionAdditional> & Partial<IVasInfo<IMultibundleAdditional>> & IFullMultibundle>,
}

const SubscriptionsLayout = ({ subscriptions }: IProps): JSX.Element => {
    const { subscriptionId } = usePrepareQueryData();
    const dispatch = useDispatch();

    const onDataLayerPush = useCallback(() => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.multibundleWidget,
            action: 'click_to_detail_page_btn',
        });
    }, []);

    const onClosePopup = useCallback(() => {
        dispatch(fetchSubscriptions());
    }, [dispatch]);

    return (
        <>
            {subscriptions?.map(subscription => subscription.vasId === multiBundleId
                ? subscription.activeVas
                    ? <MultibundleWidget key={subscription.serviceId} multibundle={subscription} onBtnClick={onDataLayerPush}/>
                    : <MultibundleCard key={subscription.serviceId} multibundle={subscription} onBtnClick={onDataLayerPush}/>
                : <SubscriptionCard
                    key={subscription.serviceId}
                    subscription={subscription}
                    queryId={Number(subscriptionId)}
                    onClosePopup={onClosePopup}
                />)}
        </>
    );
};

export default SubscriptionsLayout;
